import React, { useMemo } from 'react';
import { View, ViewStyle } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import { getStyles } from './Background.styles';

interface Props {
  children: React.ReactNode;
  containerStyle?: ViewStyle | ViewStyle[];
}

const Background: React.FC<Props> = ({ children, containerStyle }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => getStyles(colors), [colors]);

  return <View style={[styles.container, containerStyle]}>{children}</View>;
};

export default Background;
